import { Course } from '@mc/api'
import { TrackingContainer } from '@mc/visibility'
import { GlobalCarousel } from 'components/GlobalCarousel'
import { LOCATION_RELATED_COURSES } from 'components/GlobalCarousel/events'
import { trackRelatedCoursesCarouselViewed } from './events'

type RelatedCoursesCarouselProps = {
  courses: Course[]
  title: string
  carouselSlug: string
  className?: string
  id?: string
}

export const RelatedCoursesCarousel = ({
  courses,
  title,
  carouselSlug,
  ...props
}: RelatedCoursesCarouselProps) => {
  if (!courses?.length) return <></>

  return (
    <section {...props}>
      <TrackingContainer
        onFirstVisible={() => trackRelatedCoursesCarouselViewed()}
      >
        <GlobalCarousel
          carouselSlug={carouselSlug}
          tiles={courses}
          location={LOCATION_RELATED_COURSES}
          title={
            <h2 className='mc-text-h2 mc-text--center mc-mb-4'>{title}</h2>
          }
        />
      </TrackingContainer>
    </section>
  )
}
